/** @type {Styles} */

const thinScrollbar = {
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0,0,0,0.15) transparent',
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(0,0,0,0.15)',
    borderRadius: 3,
  },
}

export const styles = {
  bannerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100vw',
    zIndex: 1300,
  },
  root: {
    display: 'flex',
    flex: 1,
    width: '100%',
    minWidth: 0, // Allow flex item to shrink below content size
    minHeight: 0, // Allow flex item to shrink — enables height: 100% on children
    overflow: 'hidden',
  },
  wrapper: {
    height: { xs: 'calc(100vh - 64px)', sm: '100vh' },
    width: '100%',
    minWidth: 0, // Allow flex item to shrink below content size
    overflow: 'hidden', // Prevent double scrollbars
    display: 'flex',
    flexDirection: 'column',
  },
  main: (topBannerHeight = 0) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'gray.0',
    width: '100%',
    minWidth: 0, // Allow flex item to shrink below content size
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden', // Prevent horizontal scroll when sidebar pushes content
    paddingBottom: { xs: '80px', md: 0 }, // Account for mobile bottom navigation
    ...(topBannerHeight > 0 && { paddingTop: `${topBannerHeight}px` }),
    ...thinScrollbar,
  }),
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    backgroundColor: 'gray.0',
    width: '100%',
    height: '100%',
    overflowY: { xs: 'hidden', md: 'auto' },
  },
  loadingRoot: {
    display: 'flex',
    minHeight: '100vh',
    height: '1px',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'gray.0',
  },
  breadcrumbs: {
    padding: 0,
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: 'gray.0',
  },
  fullWidth: (topBannerHeight = 0) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'gray.0',
    width: '100%',
    minWidth: 0, // Allow flex item to shrink below content size
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden', // Prevent horizontal scroll when sidebar pushes content
    marginLeft: 0,
    paddingBottom: { xs: '80px', md: 0 }, // Account for mobile bottom navigation
    ...(topBannerHeight > 0 && { paddingTop: `${topBannerHeight}px` }),
    ...thinScrollbar,
  }),
}
